var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component"},_vm._l((_vm.data),function(item,key){return _c('li',{key:key},[_vm._t(("list-item-" + key),[_vm._v("\n            "+_vm._s(item)+"\n        ")],{"item":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }